module.exports = __webpack_public_path__ + "static/media/cg7.00303baa.jpg";